import { useEffect } from 'react';
import { toast } from 'sonner';

/**
 * PWA: listen for service worker + browser online/offline and surface sonner toasts.
 */
export function PwaRuntimeBridge() {
  useEffect(() => {
    const onPwa = (e) => {
      const d = e.detail;
      if (!d) return;
      if (d.kind === 'cached') {
        toast.success('Aplikasi siap digunakan tanpa jaringan untuk tampilan dasar', {
          id: 'pwa-cached',
          duration: 6000,
        });
        return;
      }
      if (d.kind === 'update' && d.registration?.waiting) {
        const { registration } = d;
        const waiting = registration.waiting;
        if (!waiting) return;

        toast('Versi baru tersedia', {
          id: 'pwa-update',
          duration: Number.POSITIVE_INFINITY,
          description: 'Muat ulang untuk menerapkan pembaruan.',
          action: {
            label: 'Perbarui',
            onClick: () => {
              let reloaded = false;
              navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (reloaded) return;
                reloaded = true;
                window.location.reload();
              });
              waiting.postMessage({ type: 'SKIP_WAITING' });
            },
          },
        });
      }
    };

    window.addEventListener('halalin-pwa', onPwa);
    return () => window.removeEventListener('halalin-pwa', onPwa);
  }, []);

  useEffect(() => {
    const onOffline = () => {
      toast.warning('Anda luring. Data terbaru dan beberapa aksi memerlukan koneksi internet.', {
        id: 'pwa-offline',
        duration: 5000,
      });
    };
    const onOnline = () => {
      toast.success('Koneksi tersambung kembali', { id: 'pwa-online', duration: 3000 });
    };

    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      onOffline();
    }
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return null;
}
